module.exports = __webpack_public_path__ + "img/s-cross.dac72fa5.png";